<template>
  <span>{{lookup.value}}</span>
</template>

<script>
export default {
  name: "Lookup",
  props: ["lookup"]
};
</script>